module.exports = __webpack_public_path__ + "static/media/creative_dna_design_logo_500px_white.bd69a588.png";